import { render, staticRenderFns } from "./TeamMenu.vue?vue&type=template&id=71aecd71&scoped=true&"
import script from "./TeamMenu.vue?vue&type=script&lang=js&"
export * from "./TeamMenu.vue?vue&type=script&lang=js&"
import style0 from "./TeamMenu.vue?vue&type=style&index=0&id=71aecd71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aecd71",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71aecd71')) {
      api.createRecord('71aecd71', component.options)
    } else {
      api.reload('71aecd71', component.options)
    }
    module.hot.accept("./TeamMenu.vue?vue&type=template&id=71aecd71&scoped=true&", function () {
      api.rerender('71aecd71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Layout/Extra/TeamMenu.vue"
export default component.exports